/* Lotus Linen — Lily chat widget.
   Self-contained: injects a floating bubble + chat panel, streams replies from
   the Cloudflare Worker. History lives in sessionStorage (per tab, per visit).
   TEST GATE: while LIVE is false, the widget only appears when the URL has
   ?lilychat=1 (the flag then sticks for the session). Flip LIVE to true to
   show it to everyone. */
(function () {
  'use strict';

  var LIVE = true;
  var WORKER_URL = 'https://lily-chat.lotus-linen.workers.dev/chat';
  var STORE_KEY = 'lily-chat-history';
  var GATE_KEY = 'lily-chat-test';
  var TEASER_KEY = 'lily-teaser-shown';

  // Avatar ships as a theme asset next to this script; derive its URL from our own tag.
  var AVATAR = '';
  try {
    var self = document.querySelector('script[src*="lily-chat.js"]');
    if (self) AVATAR = self.src.replace(/lily-chat\.js[^"']*$/, 'lily-avatar.jpg');
  } catch (e) {}

  try {
    if (new URLSearchParams(location.search).get('lilychat') === '1') {
      sessionStorage.setItem(GATE_KEY, '1');
    }
    if (!LIVE && sessionStorage.getItem(GATE_KEY) !== '1') return;
  } catch (e) {
    if (!LIVE) return;
  }

  var GREETING = "Hi, I'm Lily! Looking for a robe, towels, or a gift? I'm happy to help you find the right one.";

  var css = [
    '#lily-bubble{position:fixed;right:18px;bottom:18px;z-index:2147483000;width:60px;height:60px;border-radius:50%;background:#234438;color:#f6f1e7;border:2px solid #f6f1e7;cursor:pointer;box-shadow:0 4px 16px rgba(0,0,0,.25);display:flex;align-items:center;justify-content:center;font-size:26px;transition:transform .15s;padding:0;overflow:hidden}',
    '#lily-bubble img{width:100%;height:100%;object-fit:cover;border-radius:50%}',
    '#lily-bubble:hover{transform:scale(1.06)}',
    '#lily-teaser{position:fixed;right:18px;bottom:88px;z-index:2147483000;width:270px;max-width:calc(100vw - 90px);background:#fffdf8;border-radius:14px;box-shadow:0 8px 28px rgba(0,0,0,.22);padding:12px 14px;display:flex;gap:10px;align-items:flex-start;cursor:pointer;font-family:Arial,Helvetica,sans-serif;font-size:13.5px;line-height:1.4;color:#2a2a26;animation:lily-in .35s ease}',
    '@keyframes lily-in{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}',
    '#lily-teaser img{width:38px;height:38px;border-radius:50%;object-fit:cover;flex-shrink:0}',
    '#lily-teaser b{font-family:Georgia,serif;display:block;margin-bottom:2px}',
    '#lily-teaser-x{position:absolute;top:4px;right:8px;background:none;border:none;color:#999;font-size:15px;cursor:pointer;padding:2px}',
    '#lily-head img{width:36px;height:36px;border-radius:50%;object-fit:cover;margin-right:10px;flex-shrink:0}',
    '#lily-head .lily-head-l{display:flex;align-items:center}',
    '#lily-panel{position:fixed;right:18px;bottom:88px;z-index:2147483001;width:360px;max-width:calc(100vw - 24px);height:520px;max-height:calc(100vh - 110px);background:#fffdf8;border-radius:16px;box-shadow:0 12px 40px rgba(0,0,0,.28);display:none;flex-direction:column;overflow:hidden;font-family:Georgia,"Times New Roman",serif}',
    '#lily-panel.open{display:flex}',
    '#lily-head{background:#234438;color:#f6f1e7;padding:14px 16px;font-size:16px;display:flex;justify-content:space-between;align-items:center}',
    '#lily-head small{display:block;font-size:11px;opacity:.75;font-family:Arial,sans-serif;margin-top:2px}',
    '#lily-close{background:none;border:none;color:#f6f1e7;font-size:20px;cursor:pointer;line-height:1}',
    '#lily-msgs{flex:1;overflow-y:auto;padding:14px;display:flex;flex-direction:column;gap:10px}',
    '.lily-m{max-width:85%;padding:9px 13px;border-radius:14px;font-size:14px;line-height:1.45;font-family:Arial,Helvetica,sans-serif;white-space:pre-wrap;word-wrap:break-word}',
    '.lily-m.bot{background:#eee9dc;color:#2a2a26;align-self:flex-start;border-bottom-left-radius:4px}',
    '.lily-m.user{background:#234438;color:#f6f1e7;align-self:flex-end;border-bottom-right-radius:4px}',
    '.lily-m a{color:#1d5c46;text-decoration:underline}',
    '.lily-m.user a{color:#cfe6da}',
    '#lily-form{display:flex;gap:8px;padding:10px;border-top:1px solid #e5dfd0;background:#fffdf8}',
    '#lily-in{flex:1;border:1px solid #d8d0bd;border-radius:20px;padding:9px 14px;font-size:16px;font-family:Arial,sans-serif;outline:none;resize:none;max-height:90px;background:#fff}',
    '#lily-in:focus{border-color:#234438}',
    '#lily-send{background:#234438;color:#f6f1e7;border:none;border-radius:20px;padding:0 16px;font-size:14px;cursor:pointer}',
    '#lily-send:disabled{opacity:.5;cursor:default}',
    '#lily-note{font-size:10px;color:#9a927c;text-align:center;padding:0 12px 7px;background:#fffdf8;font-family:Arial,sans-serif;line-height:1.35}',
    '.lily-typing{opacity:.6;font-style:italic}',
    /* Mobile: full-screen sheet, page locked behind it, no floating-box mess */
    '@media (max-width:640px){',
    '#lily-panel{left:0;right:0;top:0;bottom:0;width:100%;max-width:100%;height:100%;max-height:100%;height:100dvh;max-height:100dvh;border-radius:0}',
    '#lily-head{padding-top:max(14px,env(safe-area-inset-top))}',
    '#lily-form{padding-bottom:max(10px,env(safe-area-inset-bottom))}',
    'html.lily-lock,html.lily-lock body{overflow:hidden!important;height:100%}',
    'html.lily-lock #lily-bubble,html.lily-lock #lily-teaser{display:none}',
    '}'
  ].join('\n');

  var isMobile = window.matchMedia('(max-width:640px)');
  function lockPage(on) {
    if (!isMobile.matches) on = false;
    document.documentElement.classList.toggle('lily-lock', on);
  }

  function esc(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  // Minimal, safe markdown: escape everything, then allow [text](https://…) links and **bold**.
  function render(md) {
    var h = esc(md);
    h = h.replace(/\[([^\]]{1,120})\]\((https:\/\/[^\s)]{1,300})\)/g, function (_, t, u) {
      return '<a href="' + u + '" target="_blank" rel="noopener">' + t + '</a>';
    });
    h = h.replace(/\*\*([^*]{1,200})\*\*/g, '<b>$1</b>');
    return h;
  }

  function loadHistory() {
    try { return JSON.parse(sessionStorage.getItem(STORE_KEY)) || []; } catch (e) { return []; }
  }
  function saveHistory(hist) {
    try { sessionStorage.setItem(STORE_KEY, JSON.stringify(hist.slice(-24))); } catch (e) {}
  }

  var history = loadHistory();
  var busy = false;

  // Stable per-visit conversation id — lets the transcript log group a session's messages.
  var cid = '';
  try {
    cid = sessionStorage.getItem('lily-cid') || '';
    if (!cid) {
      cid = 'w' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
      sessionStorage.setItem('lily-cid', cid);
    }
  } catch (e) { cid = 'w' + Date.now().toString(36); }

  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  var bubble = document.createElement('button');
  bubble.id = 'lily-bubble';
  bubble.setAttribute('aria-label', 'Chat with Lily');
  bubble.innerHTML = AVATAR
    ? '<img src="' + AVATAR + '" alt="Lily" onerror="this.parentNode.innerHTML=\'&#128172;\'">'
    : '&#128172;';
  document.body.appendChild(bubble);

  var panel = document.createElement('div');
  panel.id = 'lily-panel';
  panel.innerHTML =
    '<div id="lily-head"><div class="lily-head-l">' +
    (AVATAR ? '<img src="' + AVATAR + '" alt="" onerror="this.remove()">' : '') +
    '<div>Lily &middot; Lotus Linen<small>Virtual concierge &mdash; here 24/7</small></div></div>' +
    '<button id="lily-close" aria-label="Close">&times;</button></div>' +
    '<div id="lily-msgs"></div>' +
    '<form id="lily-form"><textarea id="lily-in" rows="1" placeholder="Ask about robes, sizing, gifts&hellip;" maxlength="2000"></textarea>' +
    '<button id="lily-send" type="submit">Send</button></form>' +
    '<div id="lily-note">AI assistant &mdash; may occasionally make mistakes. Please don\'t share sensitive info. Human help: hello@shoplotuslinen.com</div>';
  document.body.appendChild(panel);

  var msgs = panel.querySelector('#lily-msgs');
  var form = panel.querySelector('#lily-form');
  var input = panel.querySelector('#lily-in');
  var sendBtn = panel.querySelector('#lily-send');

  function addMsg(role, text) {
    var el = document.createElement('div');
    el.className = 'lily-m ' + (role === 'user' ? 'user' : 'bot');
    el.innerHTML = render(text);
    msgs.appendChild(el);
    msgs.scrollTop = msgs.scrollHeight;
    return el;
  }

  function openPanel() {
    panel.classList.add('open');
    lockPage(true);
    if (!msgs.children.length) {
      history.forEach(function (m) { addMsg(m.role, m.content); });
      if (!history.length) addMsg('assistant', GREETING);
    }
    msgs.scrollTop = msgs.scrollHeight;
    if (!isMobile.matches) input.focus(); // no auto-focus on mobile — let them tap when ready, keyboard stays down
  }
  function closePanel() {
    panel.classList.remove('open');
    lockPage(false);
  }
  bubble.addEventListener('click', function () {
    removeTeaser();
    panel.classList.contains('open') ? closePanel() : openPanel();
  });
  panel.querySelector('#lily-close').addEventListener('click', closePanel);

  // Proactive teaser: once per visit, 5s after load, auto-hides after 25s.
  var teaser = null;
  function removeTeaser() {
    if (teaser) { teaser.remove(); teaser = null; }
    try { sessionStorage.setItem(TEASER_KEY, '1'); } catch (e) {}
  }
  function showTeaser() {
    try { if (sessionStorage.getItem(TEASER_KEY) === '1') return; } catch (e) {}
    if (history.length || panel.classList.contains('open')) return;
    teaser = document.createElement('div');
    teaser.id = 'lily-teaser';
    teaser.innerHTML =
      (AVATAR ? '<img src="' + AVATAR + '" alt="" onerror="this.remove()">' : '') +
      '<div><b>Lily is here &mdash; live</b>Hi! Questions about robes, sizing, or a gift? Ask me anything, any time.</div>' +
      '<button id="lily-teaser-x" aria-label="Dismiss">&times;</button>';
    document.body.appendChild(teaser);
    teaser.addEventListener('click', function (e) {
      var dismiss = e.target && e.target.id === 'lily-teaser-x';
      removeTeaser();
      if (!dismiss) openPanel();
    });
    setTimeout(function () { if (teaser) removeTeaser(); }, 25000);
  }
  setTimeout(showTeaser, 5000);

  input.addEventListener('focus', function () {
    setTimeout(function () { msgs.scrollTop = msgs.scrollHeight; }, 350); // keep last message visible when keyboard slides up
  });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      form.dispatchEvent(new Event('submit'));
    }
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var text = input.value.trim();
    if (!text || busy) return;
    input.value = '';
    busy = true;
    sendBtn.disabled = true;

    addMsg('user', text);
    history.push({ role: 'user', content: text });
    saveHistory(history);

    var botEl = addMsg('assistant', '…');
    botEl.classList.add('lily-typing');
    var acc = '';

    fetch(WORKER_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ messages: history, cid: cid }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('http ' + res.status);
        var reader = res.body.getReader();
        var dec = new TextDecoder();
        var buf = '';
        function pump() {
          return reader.read().then(function (r) {
            if (r.done) return finish();
            buf += dec.decode(r.value, { stream: true });
            var lines = buf.split('\n\n');
            buf = lines.pop();
            lines.forEach(function (line) {
              if (line.indexOf('data: ') !== 0) return;
              try {
                var ev = JSON.parse(line.slice(6));
                if (ev.t) {
                  acc += ev.t;
                  botEl.classList.remove('lily-typing');
                  botEl.innerHTML = render(acc);
                  msgs.scrollTop = msgs.scrollHeight;
                }
                if (ev.error) { acc = acc || ev.error; botEl.innerHTML = render(acc); }
              } catch (e2) {}
            });
            return pump();
          });
        }
        return pump();
      })
      .catch(function () {
        acc = acc || "Hmm, I couldn't connect just now. Mind trying again in a moment? You can always email hello@shoplotuslinen.com too.";
        botEl.classList.remove('lily-typing');
        botEl.innerHTML = render(acc);
      })
      .then(function finishOuter() {
        if (acc) {
          history.push({ role: 'assistant', content: acc });
          saveHistory(history);
        } else {
          botEl.remove();
        }
        busy = false;
        sendBtn.disabled = false;
      });

    function finish() {}
  });
})();
